// Configure Stripe
angular.module('tgaAdmin').config(['stripeProvider', 'envServiceProvider',
  function (stripeProvider, envServiceProvider) {
    if (envServiceProvider.get() === 'production') {
      stripeProvider.setPublishableKey('pk_live_Fb5VVQ7pXDoDsbwhGlErMTwG');
    } else {
      stripeProvider.setPublishableKey('pk_test_H9gB2groweXRFrm8cyGYSeeI');
    }
  },
]);
